__turbopack_context__.v({
  "ctaButton": "MainNav-module-scss-module__nBQJ8a__ctaButton",
  "ctaItem": "MainNav-module-scss-module__nBQJ8a__ctaItem",
  "ctaList": "MainNav-module-scss-module__nBQJ8a__ctaList",
  "mainNav": "MainNav-module-scss-module__nBQJ8a__mainNav",
  "mainNavWrapper": "MainNav-module-scss-module__nBQJ8a__mainNavWrapper",
  "navList": "MainNav-module-scss-module__nBQJ8a__navList",
  "pill": "MainNav-module-scss-module__nBQJ8a__pill",
  "stack-module-0": "MainNav-module-scss-module__nBQJ8a__stack-module-0",
  "stack-module-1": "MainNav-module-scss-module__nBQJ8a__stack-module-1",
  "stack-module-10": "MainNav-module-scss-module__nBQJ8a__stack-module-10",
  "stack-module-11": "MainNav-module-scss-module__nBQJ8a__stack-module-11",
  "stack-module-12": "MainNav-module-scss-module__nBQJ8a__stack-module-12",
  "stack-module-13": "MainNav-module-scss-module__nBQJ8a__stack-module-13",
  "stack-module-14": "MainNav-module-scss-module__nBQJ8a__stack-module-14",
  "stack-module-15": "MainNav-module-scss-module__nBQJ8a__stack-module-15",
  "stack-module-16": "MainNav-module-scss-module__nBQJ8a__stack-module-16",
  "stack-module-17": "MainNav-module-scss-module__nBQJ8a__stack-module-17",
  "stack-module-18": "MainNav-module-scss-module__nBQJ8a__stack-module-18",
  "stack-module-19": "MainNav-module-scss-module__nBQJ8a__stack-module-19",
  "stack-module-2": "MainNav-module-scss-module__nBQJ8a__stack-module-2",
  "stack-module-20": "MainNav-module-scss-module__nBQJ8a__stack-module-20",
  "stack-module-3": "MainNav-module-scss-module__nBQJ8a__stack-module-3",
  "stack-module-4": "MainNav-module-scss-module__nBQJ8a__stack-module-4",
  "stack-module-5": "MainNav-module-scss-module__nBQJ8a__stack-module-5",
  "stack-module-6": "MainNav-module-scss-module__nBQJ8a__stack-module-6",
  "stack-module-7": "MainNav-module-scss-module__nBQJ8a__stack-module-7",
  "stack-module-8": "MainNav-module-scss-module__nBQJ8a__stack-module-8",
  "stack-module-9": "MainNav-module-scss-module__nBQJ8a__stack-module-9",
  "z-base": "MainNav-module-scss-module__nBQJ8a__z-base",
  "z-content": "MainNav-module-scss-module__nBQJ8a__z-content",
  "z-footer": "MainNav-module-scss-module__nBQJ8a__z-footer",
  "z-header": "MainNav-module-scss-module__nBQJ8a__z-header",
  "z-hero": "MainNav-module-scss-module__nBQJ8a__z-hero",
  "z-logo": "MainNav-module-scss-module__nBQJ8a__z-logo",
  "z-logo-effect": "MainNav-module-scss-module__nBQJ8a__z-logo-effect",
  "z-navigation": "MainNav-module-scss-module__nBQJ8a__z-navigation",
  "z-sub": "MainNav-module-scss-module__nBQJ8a__z-sub",
});
